// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-2aaJN","title":"title-2JI20","icon":"icon-3RQvj","conditions":"conditions-21BZs"};